import { supabase } from "~/integrations/supabase/client";

import type {
  SupplierCompanyProfile,
  SupplierCompanyProfileFormData,
} from "~/types/purchasing";

// `supplier_company_profiles` postdates the last generated supabase types — cast the query
// builder (same approach as accountingCategoryService / fg_plant_transfers). RLS allows writes
// only for superadmin/admin/produccion-admin; the page is route-gated to superadmin/admin.
const from = supabase.from.bind(supabase) as unknown as (table: string) => any;

const SELECT =
  "*, " +
  "company:company_id(id, name), " +
  "default_expense_account:default_expense_account_id(id, code, name)";

export const supplierCompanyProfileService = {
  async listBySupplier(supplierId: string): Promise<SupplierCompanyProfile[]> {
    const { data, error } = await from("supplier_company_profiles")
      .select(SELECT)
      .eq("supplier_id", supplierId)
      .order("created_at", { ascending: true });
    if (error) throw error;
    return (data ?? []) as SupplierCompanyProfile[];
  },

  async create(
    formData: SupplierCompanyProfileFormData
  ): Promise<SupplierCompanyProfile> {
    const { data, error } = await from("supplier_company_profiles")
      .insert(formData)
      .select(SELECT)
      .single();
    if (error) throw error;
    return data as SupplierCompanyProfile;
  },

  async update(
    id: string,
    formData: Partial<SupplierCompanyProfileFormData>
  ): Promise<SupplierCompanyProfile> {
    const { data, error } = await from("supplier_company_profiles")
      .update(formData)
      .eq("id", id)
      .select(SELECT)
      .single();
    if (error) throw error;
    return data as SupplierCompanyProfile;
  },

  async delete(id: string): Promise<void> {
    const { error } = await from("supplier_company_profiles")
      .delete()
      .eq("id", id);
    if (error) throw error;
  },
};
